import http from "./HttpService";

/**
 * Funktion für das DoubleOptIn
 * @param token das Token, welches an den Server gesendet werden soll
 * @returns {Promise<>}
 */
export function optIn(token) {
    return http.post("/doubleoptin/confirm/", token, { headers: { "Content-Type": "text/plain" } });
}
